export function getDaysBetweenDates(start: Date, end: Date): number {
    let startDate = new Date(start)
    let endDate = new Date(end)
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    // 确保startDate不晚于endDate
    if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
    }

    // 计算时间差（以毫秒为单位）
    const timeDifference = endDate.getTime() - startDate.getTime();

    // 将时间差转换为天数
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

    // 返回整数天数
    return Math.floor(daysDifference);
}
export function getMonthsBetweenDates(start: Date, end: Date): number {
    let startDate = new Date(start)
    let endDate = new Date(end)
    startDate.setHours(0, 0, 0, 0);
    startDate.setDate(1)
    endDate.setHours(0, 0, 0, 0);
    endDate.setDate(1)
    // 确保startDate不晚于endDate
    if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
    }

    // 计算时间差（以毫秒为单位）
    const timeDifference = endDate.getTime() - startDate.getTime();

    // 将时间差转换为天数
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24 * 30);

    // 返回整数天数
    return Math.round(daysDifference);
}
export const getMonthDays = (date: Date) => {
    const nextMonth = new Date(date.getFullYear(), date.getMonth() + 2, 0); // 设置为下个月的第一天，然后减去一天
    return nextMonth.getDate(); // 获取当前月份的天数
}

export const enum k_dateType {
    week,
    month,
    season,
    year,
    all
}